// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type JourneyContextProperties = {
  return_is_routed_connection?: boolean;
  lowest_price_in_cents?: number;
  id: number;
  arrival_position_id?: number;
  is_fully_onsite?: boolean;
  departure_position_id?: number;
  return_duration_minutes?: number;
  currency?: string;
  num_offers?: number;
  is_inbound_direct?: boolean;
  return_lowest_price_in_cents?: number;
  is_fully_direct?: boolean;
  travel_mode?: string;
  is_outbound_direct?: boolean;
  duration_minutes?: number;
  lowest_price_euro_cents?: number;
  is_routed_connection?: boolean;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/journey_context/jsonschema/4-0-1';
export const journeyContextName = 'journey_context';
export class JourneyContext extends BaseTrackingContext<JourneyContextProperties> {
  constructor(properties: JourneyContextProperties) {
    super(journeyContextName, schema, properties);
  }
}
